/* import __COLOCATED_TEMPLATE__ from './secondary-workspace-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();